import React, { useContext } from 'react';
import EmptyBackground from '../EmptyBackground';
import BackgroundImage from '../../BackgroundImage';
import { ThemeOptions } from '../../../publicSession/types';
import { ThemeContext } from '../../../Context';
var LARGE_BACKGROUND_MIN_SIZE = 1300; // TODO correct breakpoint
function pickBackgroundSrc(background, theme, width) {
    var useLarge = width && width > LARGE_BACKGROUND_MIN_SIZE;
    switch (theme) {
        case ThemeOptions.LIGHT:
            return useLarge ? background.lightBigUrl : background.lightSmallUrl;
        case ThemeOptions.DARK:
        default:
            return useLarge ? background.darkBigUrl : background.darkSmallUrl;
    }
}
export var DefaultStageBackground = function (_a) {
    var width = _a.width, deviation = _a.deviation, _b = _a.background, background = _b === void 0 ? deviation.background || 'default' : _b;
    var theme = useContext(ThemeContext);
    if (background === 'default') {
        return React.createElement(EmptyBackground, null);
    }
    return (React.createElement(BackgroundImage, { src: pickBackgroundSrc(background, theme, width), fade: "small" }));
};
DefaultStageBackground.displayName = 'DefaultStageBackground';
export default DefaultStageBackground;
//# sourceMappingURL=Default.js.map